import type { ComponentStyleConfig } from '@chakra-ui/react';

import { label } from '../typography';

const FormLabelComponentStyle: ComponentStyleConfig = {
  baseStyle: {
    ...label(),
    mb: 2,
    color: 'primary600',
  },
};

export default FormLabelComponentStyle;
